import React, { Fragment } from 'react';

const FloorInfo = ({ floor, floorLoading }) => {
  return (
    <Fragment>
      {floorLoading ? (
        <div className='card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content'>
          <div className='d-flex justify-content-center align-items-center h-100'>
            <div class='spinner-border txt-primary' role='status'>
              <span class='visually-hidden'>Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className='card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content'>
          <div className='mb-3'>
            <h5 className='fw-bold'>Id</h5>
            <div className=''>{floor.id}</div>
          </div>
          <div className='mb-3'>
            <h5 className='fw-bold'>Name</h5>
            <div className=''>{floor.floor}</div>
          </div>
          <div className='mb-3'>
            <h5 className='fw-bold'>Building</h5>
            <div className=''>{floor.building_name}</div>
          </div>

          <div className='mb-3'>
            <h5 className='fw-bold'>Image</h5>
            <img src={floor.image} alt='' className='' height='200' />
          </div>
          <div className='mb-3'>
            <h5 className='fw-bold'>Display Image</h5>
            <img src={floor.displayImage} alt='' className='' height='200' />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default FloorInfo;
